// extracted by mini-css-extract-plugin
export default {"homePageContainer":"HomePage_homePageContainer__+l0xT","skeletonContainer":"HomePage_skeletonContainer__QoD8+"};